<template>
  <div :class="classModifiers">
    <div class="popup-generic-small__icon" v-if="currentPopupOptions.icon">
      <img src="@/assets/icons/fail-icon.svg" alt="" v-if="currentPopupOptions.icon === 'error'" />
      <img
        src="@/assets/icons/success-icon.svg"
        alt=""
        v-if="currentPopupOptions.icon === 'success'"
      />
    </div>
    <div class="popup-generic-small__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script src="./generic-small.js"></script>
<style src="./generic-small.scss" lang="scss"></style>
